import User from './user';

/**
 * Delegate details
 *
 * @Constructor Delegate
 * @param {Object} options Optional configuration.
 * @api public
 */
export default class Delegate extends User {
  /**
   * Update data from the idp cookie
   *
   * @api private
   */
  updateFromCookie() {
    this.cookies.updateIdp();

    this.set(this.cookies.getIdpProperties([
      'firstname',
      'lastname',
      'info_accountname',
      'jti'
    ].map(property => ['del', property]), {
      info_accountname: 'accountName'
    }));
  }
}
